"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import $ from "jquery";
import Account from "../api/account";
import DocumentGroupList from "./document_browser/document_group_list";
import DocumentBrowserMainImage from "./document_browser/main_image";
import DocumentBrowserShell from "./document_browser/shell";
import * as popout from "./popout";
import {
  DocumentBrowserUpdateNotifier
} from "./grouped_document_browser_model";
import hotkeys from "../util/hotkeys";
import React from "react";
import _ from "underscore";
import { setPOD } from "../helpers/documents";
import { isAddDocumentToLoadEnabled } from "./document_browser/add_document_to_load_enabled";
import addDocumentToLoadUpdateHandlerService from "./add_document_to_load_update_handler_service";
import { title } from "../formatters/documents";
import { push } from "./app_history";
const ON_POPOUT_LISTENER_NAME = "react_document_browser";
function modelGroups(model) {
  return model.groups;
}
function selectInvoicePageOnFirstLoad(props) {
  if (!props.isConfirmAndSubmit || props.location.query.isFirstLoad !== "true") {
    return;
  }
  var doc = _.first(
    _.where(props.model.selectedGroup.documents, {
      type: "invoice"
    })
  );
  if (!doc) {
    var doc = _.first(
      _.where(props.model.selectedGroup.documents, {
        type: "factorInvoice"
      })
    );
  }
  if (doc) {
    props.model.selectPage(doc.pages[0]);
  }
}
class DocumentBrowser extends React.Component {
  constructor(props) {
    super(props);
    // The parent's selectedComponent only switches tabs when it changes, and not on mount.
    __publicField(this, "state", { prevSelectedComponentProp: this.props.selectedComponent });
    __publicField(this, "mounted", false);
    __publicField(this, "setPopoutData", () => {
      var _a, _b;
      const documentBatch = this.props.documentBatch;
      const documentPage = this.props.model.selectedPage;
      const isConfirmAndSubmit = this.props.isConfirmAndSubmit;
      let documentGroup = this.props.model.selectedGroup;
      const documentGroups = this.getDocumentGroupList();
      if (!documentGroup && documentGroups && documentGroups.length == 1) {
        documentGroup = documentGroups[0];
      }
      let maybeCarrierInvoiceId;
      if (this.props.carrierInvoice) {
        maybeCarrierInvoiceId = this.props.carrierInvoice.id;
      } else if ((_b = (_a = this.props.location) == null ? void 0 : _a.query) == null ? void 0 : _b.referringCarrierInvoiceId) {
        maybeCarrierInvoiceId = parseInt(
          this.props.location.query.referringCarrierInvoiceId
        );
      }
      popout.setCurrentProcessingSelection(
        documentBatch,
        documentGroup,
        documentPage,
        isConfirmAndSubmit,
        maybeCarrierInvoiceId
      );
    });
    __publicField(this, "modelUpdated", () => {
      if (this.props.model && this.mounted) {
        this.forceUpdate();
      }
    });
    __publicField(this, "handleSelectPageEvent", (_event, documentPageId) => {
      const page = this.getDocumentPageById(documentPageId);
      if (page) {
        this.pageSelected(page);
      }
    });
    __publicField(this, "handleStorageUpdate", (event) => {
      if (!popout.isAccountEnabled()) {
        return;
      }
      if (event.key === popout.CURRENT_PROCESSING_SELECTION_KEY) {
        const [source, selection] = JSON.parse(event.newValue);
        if (source !== popout.CURRENT_PROCESSING_SELECTION_SOURCE_POPOUT) {
          return;
        }
        const selectedGroup = this.getDocumentGroupById(
          selection.documentGroupId
        );
        const selectedDocumentPage = this.getDocumentPageById(
          selection.documentPageId
        );
        const existingSelectedDocumentPageId = !!this.props.model.selectedPage && this.props.model.selectedPage.id;
        if (selectedDocumentPage && selectedDocumentPage.id !== existingSelectedDocumentPageId) {
          this.props.model.selectPage(selectedDocumentPage);
        } else if (selectedGroup && selectedGroup.documents[0].pages[0].id !== existingSelectedDocumentPageId) {
          this.props.model.selectPage(selectedGroup.documents[0].pages[0]);
        }
        if (selectedGroup && (this.state.selectedGroup !== selectedGroup || this.state.selectedComponent !== "Documents")) {
          this.setState({
            selectedGroup,
            selectedComponent: "Documents"
          });
        }
      } else if (event.key === popout.DOCUMENT_POD_UPDATES_KEY) {
        const update = popout.getMaybeDocumentPodUpdate();
        if (update) {
          const document = this.allDocuments().find(
            (doc) => doc.id === update.documentId
          );
          if (document) {
            setPOD(document, !!update.isPOD);
          }
        }
      } else if (this.popoutClosedEvent(event)) {
        this.maybeRedirectOnClose(popout.VIEW_EMAIL_FORWARD_DATA_KEY);
      }
    });
    __publicField(this, "popoutClosedEvent", (event) => {
      return event.key === popout.DOCUMENT_VIEWER_OPEN_LOCAL_STORAGE_KEY && !popout.isDocumentViewerOpen();
    });
    __publicField(this, "maybeRedirectOnClose", (storageKey) => {
      const documentData = JSON.parse(
        window.localStorage.getItem(storageKey)
      );
      if (documentData && documentData.forwardUrl) {
        window.localStorage.removeItem(storageKey);
        const onDone = this.props.location.query.onDone || "/dashboard";
        if (documentData.invoiceId) {
          const invoiceId = documentData.invoiceId;
          push(documentData.forwardUrl, {
            invoiceId,
            onDone
          });
        } else {
          push(documentData.forwardUrl, { onDone });
        }
      }
    });
    __publicField(this, "getDocumentGroupById", (groupId) => {
      return groupId ? modelGroups(this.props.model).find((group) => group.id == groupId) : void 0;
    });
    __publicField(this, "getDocumentPageById", (docPageId) => {
      const documents = this.allDocuments();
      return this.getPageFromDocList(documents, docPageId);
    });
    __publicField(this, "allDocuments", () => {
      const documents = modelGroups(this.props.model).flatMap((group) => {
        return group.documents;
      });
      return documents;
    });
    __publicField(this, "getPageFromDocList", (docs, docPageId) => {
      return docPageId ? docs.flatMap((doc) => doc.pages).find((page) => page.id == docPageId) : void 0;
    });
    // STATE
    __publicField(this, "pageSelected", (page) => {
      this.props.model.selectPage(page);
      this.setState({ selectedComponent: "Documents" });
    });
    __publicField(this, "printTest", () => {
      return /* @__PURE__ */ jsx("div", { className: "document-browser__main-image-container", children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("h1", { children: "Test!" }) }) });
    });
    __publicField(this, "mainImage", () => {
      return /* @__PURE__ */ jsx(
        DocumentBrowserMainImage,
        {
          isConfirmAndSubmit: this.props.isConfirmAndSubmit,
          model: this.props.model,
          allowsEditing: this.props.allowsEditing,
          allowsSplitMerge: this.props.allowsSplitMerge,
          textToHighlight: this.props.textToHighlight,
          toggleDocumentData: this.props.toggleDocumentData,
          toggleMarkIllegibleData: this.props.toggleMarkIllegibleData,
          toggleHiddenData: this.props.toggleHiddenData,
          toggleCarrierDocument: this.props.toggleCarrierDocument,
          toggleDeliveryDocument: this.props.toggleDeliveryDocument,
          toggleShipmentDocument: this.props.toggleShipmentDocument,
          toggleCustomerLoadDocument: this.props.toggleCustomerLoadDocument,
          allowsEditingPodStatus: this.props.allowsEditingPodStatus,
          currentInvoice: this.props.currentInvoice,
          toggleClientDebtorCheck: this.props.toggleClientDebtorCheck,
          savingInvoice: this.props.savingInvoice,
          browserExpanded: this.props.browserExpanded,
          canDownloadAll: this.props.canDownloadAll,
          load: this.props.load,
          documentBatch: this.props.documentBatch,
          carrier: this.props.carrier,
          page: this.props.model.selectedPage,
          location: this.props.location,
          shipments: this.props.shipments,
          selectedLoad: this.props.selectedLoad,
          shipmentDocumentSelections: this.props.shipmentDocumentSelections,
          deliveryDocumentSelections: this.props.deliveryDocumentSelections,
          removeDeliveryDocumentSelectionsForDocument: this.props.removeDeliveryDocumentSelectionsForDocument,
          startDeliveryDocumentRefresh: this.props.startDeliveryDocumentRefresh,
          updateShipments: this.props.updateShipments,
          forceUpdateAndRefreshPopout: this.props.forceUpdateAndRefreshPopout,
          documentLoadRelationships: this.props.documentLoadRelationships
        }
      );
    });
    __publicField(this, "selectedComponent", () => {
      const defaultComponentLabel = this.props.initialSelectedComponent || "Documents";
      const selectedLabel = this.state.selectedComponent || defaultComponentLabel;
      return this.possibleComponents().find(
        (component) => component.label == selectedLabel
      );
    });
    __publicField(this, "documentsAreShowing", () => {
      return this.props.model.selectedPage && this.selectedComponent().label == "Documents";
    });
    __publicField(this, "selectedComponentView", () => {
      const component = this.selectedComponent();
      if (this.documentsAreShowing()) {
        return component.component;
      } else {
        return /* @__PURE__ */ jsx("div", { className: "document-browser__main-image-container", children: component.component });
      }
    });
    __publicField(this, "possibleComponents", () => {
      const defaultComponents = [
        { label: "Documents", component: this.mainImage() }
      ];
      return defaultComponents.concat(this.props.additionalComponents || []);
    });
    __publicField(this, "componentSelected", (component) => {
      this.setState({ selectedComponent: component.label });
    });
    __publicField(this, "currentPageId", () => {
      return this.currentPage().id;
    });
    __publicField(this, "currentPage", () => {
      return this.props.model.selectedPage;
    });
    __publicField(this, "possibleEditTypeLink", () => {
      if (this.props.canEditDocumentType && !this.props.leftSelected) {
        return /* @__PURE__ */ jsxs(
          "a",
          {
            className: "document-browser__edit-type-link",
            onClick: this.props.editDocumentType,
            title: "Edit doctype - Alt+E or * (Numpad)",
            children: [
              /* @__PURE__ */ jsx("span", { children: "\xA0" }),
              /* @__PURE__ */ jsx("i", { className: "fi-pencil" })
            ]
          }
        );
      }
    });
    __publicField(this, "possibleToggleDocumentsLink", () => {
      if (!Account.showAllLoadDocumentsEnabled() && this.otherDocumentsAvailable()) {
        return /* @__PURE__ */ jsx(
          "a",
          {
            className: "document-browser__toggle-docs-link",
            onClick: this.toggleDocumentsView,
            children: this.toggleDocumentsText()
          }
        );
      }
    });
    __publicField(this, "toggleDocumentsView", () => {
      push(this.props.location.pathname, this.loadDocumentsParams());
      this.props.toggleDocumentsCallback();
    });
    __publicField(this, "loadDocumentsParams", () => {
      var _a;
      if (this.showingAllDocuments()) {
        delete this.props.location.query.showLoadDocuments;
        delete this.props.location.query.referringCarrierInvoiceId;
        return this.props.location.query;
      } else {
        return _.extend(this.props.location.query, {
          showLoadDocuments: true,
          referringCarrierInvoiceId: (_a = this.props.carrierInvoice) == null ? void 0 : _a.id
        });
      }
    });
    __publicField(this, "otherDocumentsAvailable", () => {
      if (this.loadDocumentsAvailable()) {
        if (this.showingAllDocuments()) {
          return this.carrierInvoiceDocumentsAvailable();
        } else {
          return true;
        }
      } else {
        return false;
      }
    });
    __publicField(this, "toggleDocumentsText", () => {
      if (this.showingAllDocuments()) {
        return "show invoice documents";
      } else {
        return "show all load documents";
      }
    });
    __publicField(this, "showingAllDocuments", () => {
      return this.props.location.query.showLoadDocuments;
    });
    __publicField(this, "carrierInvoiceDocumentsAvailable", () => {
      return !_.isEmpty(this.props.load.carrier_invoices);
    });
    __publicField(this, "loadDocumentsAvailable", () => {
      return this.props.loadDocumentsAvailable;
    });
    __publicField(this, "mainImageTitle", () => {
      if (this.documentsAreShowing()) {
        return /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("span", { children: this.currentDocumentType() }),
          this.possibleEditTypeLink(),
          this.possibleToggleDocumentsLink()
        ] });
      } else {
        const toggleLink = this.possibleToggleDocumentsLink();
        if (toggleLink) {
          return /* @__PURE__ */ jsx("div", { children: toggleLink });
        }
      }
    });
    __publicField(this, "possibleExpandLink", () => {
      if (this.props.expandBrowser) {
        const expandClass = this.props.browserExpanded ? "compress" : "expand";
        return /* @__PURE__ */ jsx(
          "a",
          {
            onClick: this.props.expandBrowser,
            className: "document-browser__header-expand_browser",
            title: this.props.browserExpanded ? "Collapse Document Browser" : "Expand Document Browser",
            children: /* @__PURE__ */ jsx("i", { className: `fi-arrows-${expandClass}` })
          }
        );
      }
    });
    __publicField(this, "possiblePopoutLink", () => {
      if (popout.isDocumentViewerPopoutEnabled()) {
        return /* @__PURE__ */ jsx(
          "a",
          {
            onClick: () => this.openDocumentViewerPopout(),
            title: "Open Document Browser in a New Window",
            children: /* @__PURE__ */ jsx("i", { className: `fi-arrows-out` })
          }
        );
      }
    });
    __publicField(this, "possibleCloseLink", () => {
      if (this.props.closeBrowser) {
        return /* @__PURE__ */ jsx("a", { onClick: this.props.closeBrowser, children: /* @__PURE__ */ jsx("i", { className: "fi-x-circle" }) });
      }
    });
    __publicField(this, "currentDocumentType", () => {
      return title(this.props.model.selectedDocument);
    });
    __publicField(this, "documentList", () => {
      if (this.documentsAreShowing()) {
        return /* @__PURE__ */ jsx(
          DocumentGroupList,
          {
            isConfirmAndSubmit: this.props.isConfirmAndSubmit,
            groups: this.getDocumentGroupList(),
            selectedPage: this.props.model.selectedPage,
            selectedGroup: this.props.model.selectedGroup,
            selectedDocument: this.props.model.selectedDocument,
            onPageSelected: this.pageSelected,
            onContextMenu: this.props.onContextMenu,
            collapseSingleGroup: this.props.collapseSingleGroup,
            location: this.props.location,
            loadState: this.props.load,
            carrierInvoice: this.props.carrierInvoice,
            documentLoadRelationships: this.props.documentLoadRelationships,
            selectedLoad: this.props.selectedLoad
          }
        );
      }
    });
    __publicField(this, "getDocumentGroupList", () => {
      return this.props.includeUnassociatedGroup ? modelGroups(this.props.model) : _.reject(modelGroups(this.props.model), function(group) {
        return group.number === "unassociated";
      });
    });
    //NOTE: localStorage events do not broadcast to the window from which they were called. modelUpdated() is called manually from these links for this reason.
    __publicField(this, "openDocumentViewerPopout", () => {
      window.open(
        this.docViewerUrl(),
        popout.DOC_VIEWER_POPOUT_NAME,
        "width=1000,height=1200"
      );
      popout.openDocumentViewer();
      this.modelUpdated();
    });
    __publicField(this, "closeDocumentViewerPopout", () => {
      if (popout.isDocumentViewerOpen()) {
        popout.closeDocumentViewer();
        this.modelUpdated();
      }
    });
    __publicField(this, "hideDocViewer", () => {
      return (Account.hasRole("Broker") || Account.useDocumentViewerPopout()) && popout.isDocumentViewerOpen();
    });
    __publicField(this, "docViewerUrl", () => {
      return "/app/documents_viewer";
    });
    __publicField(this, "addDocumentToLoadEnabled", () => {
      return isAddDocumentToLoadEnabled(
        !!this.props.isConfirmAndSubmit,
        this.props.load,
        this.props.carrierInvoice
      );
    });
    selectInvoicePageOnFirstLoad(props);
  }
  static getDerivedStateFromProps(props, state) {
    if (props.selectedComponent === state.prevSelectedComponentProp) {
      return null;
    }
    return props.selectedComponent ? {
      selectedComponent: props.selectedComponent,
      prevSelectedComponentProp: props.selectedComponent
    } : { prevSelectedComponentProp: props.selectedComponent };
  }
  componentDidMount() {
    var _a, _b, _c, _d;
    this.mounted = true;
    $(DocumentBrowserUpdateNotifier).on("updated", this.modelUpdated);
    $(DocumentBrowserUpdateNotifier).on(
      "selectPage",
      this.handleSelectPageEvent
    );
    if (popout.isAccountEnabled()) {
      popout.registerOnPopoutToggleListener(
        ON_POPOUT_LISTENER_NAME,
        this.modelUpdated
      );
    }
    if (this.addDocumentToLoadEnabled()) {
      addDocumentToLoadUpdateHandlerService.startService(
        ((_a = this.props.load) == null ? void 0 : _a.id) || null
      );
    }
    window.addEventListener("storage", this.handleStorageUpdate);
    if (this.props.canEditDocumentType && !this.props.leftSelected) {
      hotkeys.listenInComponent(this, AccountsPayable, {
        // Every parent that passes canEditDocumentType also passes editDocumentType.
        changeDoctype: this.props.editDocumentType
      });
    }
    this.setPopoutData();
    const pageData = {
      carrierInvoiceId: (_b = this.props.carrierInvoice) == null ? void 0 : _b.id,
      loadStateId: (_c = this.props.load) == null ? void 0 : _c.id,
      carrierInvoiceHasSubmission: (_d = this.props.carrierInvoice) == null ? void 0 : _d.has_carrier_ltl_items
    };
    popout.setPageContextData(pageData);
  }
  componentDidUpdate() {
    this.setPopoutData();
  }
  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener("storage", this.handleStorageUpdate);
    hotkeys.unlistenInComponent(this);
    popout.unregisterOnPopoutToggleListener(ON_POPOUT_LISTENER_NAME);
    $(DocumentBrowserUpdateNotifier).off("updated", this.modelUpdated);
    $(DocumentBrowserUpdateNotifier).off(
      "selectPage",
      this.handleSelectPageEvent
    );
    if (this.addDocumentToLoadEnabled()) {
      addDocumentToLoadUpdateHandlerService.stopService();
    }
  }
  // RENDER
  render() {
    return /* @__PURE__ */ jsxs(
      DocumentBrowserShell,
      {
        "data-component": "DocumentBrowser",
        mainImageTitle: this.mainImageTitle(),
        selectableComponents: this.possibleComponents(),
        selectedComponent: this.selectedComponent(),
        componentSelected: this.componentSelected,
        closeLink: this.possibleCloseLink(),
        expandLink: this.possibleExpandLink(),
        popoutLink: this.possiblePopoutLink(),
        hideDocViewer: this.hideDocViewer(),
        closeDocumentViewerPopout: this.closeDocumentViewerPopout,
        popoutReplacementChild: this.props.popoutReplacementChild,
        documentsTitle: "Documents",
        children: [
          this.selectedComponentView(),
          this.documentList()
        ]
      }
    );
  }
}
export default DocumentBrowser;
